'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var RulesPanelController = function RulesPanelController($scope, $state, $log, $timeout, strategyConstants, rulesService, rulesStateService, dataRetrieverService, dataRetrieverConstants, panelStateManager, serializeRuleService, saveRuleService, dataService, StrategyCondition, Rule, conditionsAndActionsService) {
  var ruleDataRetrieve;
  var transferredRuleSelected = false;
  function getPanelType() {
    if ($state.params.transitionData && $state.params.transitionData.panel) {
      return $state.params.transitionData.panel;
    }
    return strategyConstants.PANEL_TYPE.OPTIMIZATION;
  }
  $scope.panelConfig = {
    activeEntityType: getPanelType()
  };
  $scope.ruleStatusOptions = strategyConstants.DROP_DOWN_DATA.RULE_STATUS;
  var defaultStrategyDomainLevel = conditionsAndActionsService.getDefaultStrategyDomainLevel();
  $scope.defaultStrategyDomainLevel = conditionsAndActionsService.getLevelByDomain(defaultStrategyDomainLevel);
  $scope.$watch('panelConfig.activeEntityType', function () {
    $scope.showDefaultView();
    setDataRetriever();
  });
  function initializePanelStateManager() {
    var panelNames = ['customRulePanel', 'ruleQuickSelection', 'ruleListing', 'readonlyPanel'];
    var initiallyVisiblePanelsNames = ['ruleListing'];
    $scope.panelsManager = panelStateManager.getInstance(panelNames, initiallyVisiblePanelsNames);
  }
  function setDataRetriever() {
    ruleDataRetrieve = dataRetrieverService.getDataRetriever(dataRetrieverConstants.RULE_SCREEN, getGridId());
  }
  function setRuleDefaults(rule) {
    rule.type = rule.type || $scope.panelConfig.activeEntityType;
    rule.status = rule.status || $scope.ruleStatusOptions[0];
    rule.primaryCriteriaLevel = rule.primaryCriteriaLevel || $scope.defaultStrategyDomainLevel;
    rule.linkCriteriaLevel = rule.linkCriteriaLevel || $scope.defaultStrategyDomainLevel;
    return rule;
  }
  initializePanelStateManager();
  setDataRetriever();
  $scope.$on('rule:createRule', function (event, ruleType) {
    removeTransitionData();
    $scope.editingRule = new Rule(setRuleDefaults({}));
    $scope.panelsManager.setVisible('ruleListing', false);
    $scope.panelsManager.setVisible('readonlyPanel', false);
    $scope.panelsManager.setVisible('customRulePanel', ruleType === strategyConstants.RuleType.CUSTOM);
    $scope.panelsManager.setVisible('ruleQuickSelection', ruleType === strategyConstants.RuleType.QUICK);
  });
  $scope.$on('search-criteria:onSearchButtonClick', function () {
    removeTransitionData();
  });
  $scope.$on('search-criteria:searchChangeEvent', function () {
    dataService.clearCache();
    $scope.showDefaultView();
  });
  $scope.$on('rule:editRule', function (event, isQuickRule, rule) {
    rule = serializeRuleService.parseRule(rule);
    rule.old = rulesService.copyRule(rule);
    rule = setRuleDefaults(rule);
    $scope.editingRule = new Rule(rule);
    $scope.panelsManager.setVisible('ruleListing', false);
    $scope.panelsManager.setVisible('customRulePanel', !isQuickRule);
    $scope.panelsManager.setVisible('ruleQuickSelection', isQuickRule);
  });
  function findRawData(gridRow, rawDataSet) {
    return _.find(rawDataSet, {
      name: gridRow.name,
      technicalId: gridRow.technicalId
    });
  }
  $scope.expandCollapseHandler = function () {
    $scope.panelsManager.togglePanelVisibility('ruleListing');
    if ($scope.panelsManager.isVisible('readonlyPanel')) {
      $scope.panelsManager.setCollapsed('readonlyPanel', $scope.panelsManager.isVisible('ruleListing'));
    }
    $scope.$broadcast('whatIfResults:collapsedGrid');
  };
  $scope.showHideHandler = function () {
    $scope.panelsManager.togglePanelHidden('readonlyPanel');
    $timeout(function () {
      $scope.$broadcast('grid:refresh:' + getGridId());
    }, 10);
  };
  $scope.showReadonlyView = function (rule) {
    var readOnly = rulesService.copyRule(rule);
    readOnly = serializeRuleService.parseRule(readOnly);
    $scope.readonlyRule = readOnly;
    $scope.panelsManager.setVisible('readonlyPanel', true);
  };
  $scope.showDefaultView = function () {
    $scope.panelsManager.setInitialVisibilityState();
    $scope.panelsManager.collapseAll();
  };
  $scope.hideReadonlyView = function () {
    $scope.showDefaultView();
    $scope.$broadcast('grid:clearSelection');
  };
  $scope.showReadOnlyRule = function (rule) {
    ruleDataRetrieve.retrieveComponentData().then(findRawData.bind(null, rule)).then($scope.showReadonlyView);
  };
  function getGridId() {
    return $scope.panelConfig.activeEntityType === strategyConstants.PANEL_TYPE.OPTIMIZATION ? dataRetrieverConstants.RULE_LISTING_MODE : dataRetrieverConstants.ALERT_RULE_LISTING_MODE;
  }
  $scope.clearPanelsManagerState = function () {
    $scope.readonlyRule = undefined;
    $scope.panelsManager.setVisible('readonlyPanel', false);
    $scope.panelsManager.setHidden('readonlyPanel', false);
    $timeout(function () {
      $scope.$broadcast('grid:refresh:' + getGridId());
    }, 10);
  };
  function reloadGrid() {
    $scope.$broadcast('grid:dataChanged');
  }
  $scope.$on('rule-listing:deleteRules', function (e, rules) {
    rulesService.removeRules(rules).then(reloadGrid);
  });
  $scope.$on('rules:dataAndSelectionChanged', function (e, data) {
    $scope.$broadcast('grid:dataAndSelectionChangedGrid:' + getGridId(), [data]);
  });
  $scope.$on('grid:afterUpdateBoundData', function () {
    if (!transferredRuleSelected && $state.params.transitionData && $state.params.transitionData.rulesIds && $state.params.transitionData.rulesIds.length === 1) {
      var selectedRule = $state.params.transitionData.rulesIds[0];
      transferredRuleSelected = true;
      $scope.$broadcast('grid:dataAndSelectionChangedGrid:' + getGridId(), [{
        technicalId: selectedRule
      }]);
    }
  });
  function triggerDataChanged(data) {
    $scope.$emit('rules:dataAndSelectionChanged', {
      name: data.name
    });
  }
  function handleDuplicatingError(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('RulesPanelController: handleDuplicatingError - ' + message);
    toastr.error(message);
  }
  $scope.$on('rule-listing:duplicateRule', function (e, ruleGridRow) {
    removeTransitionData();
    ruleDataRetrieve.retrieveComponentData().then(findRawData.bind(null, ruleGridRow)).then(saveRuleService.duplicateRule).then(triggerDataChanged, handleDuplicatingError);
  });
  $scope.toggleReadOnlyPanelVisibilityState = function () {
    $scope.$broadcast('readOnly:resetView');
    var selectedRow = rulesStateService.getSelectedRow();
    if (selectedRow !== null) {
      $scope.showReadOnlyRule(selectedRow);
    } else {
      $scope.clearPanelsManagerState();
    }
  };
  $scope.$on('rules:toggleReadOnlyPanelVisibility', $scope.toggleReadOnlyPanelVisibilityState);
  $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId) {
    if (gridId === 'rule-listing' || gridId === 'alert-rule-listing') {
      rulesStateService.setSelectedRows(selectedRows);
      $scope.toggleReadOnlyPanelVisibilityState();
    }
    $timeout(function () {
      $scope.$broadcast('grid:refresh:' + gridId);
    }, 10);
  });
  function removeTransitionData() {
    $state.params.transitionData = null;
  }
};
RulesPanelController.$inject = ['$scope', '$state', '$log', '$timeout', 'StrategyConstants', 'RulesService', 'RulesStateService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'PanelStateManager', 'SerializeRuleService', 'SaveRuleService', 'DataService', 'StrategyConditionFactory', 'RuleFactory', 'ConditionsAndActionsService'];
module.exports = RulesPanelController;